module.exports = __webpack_public_path__ + "img/1800.f64390b7.jpg";